import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 12,
	viewBox: "0 0 16 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.29289 8.52141L3.25008 4.47859C2.62011 3.84863 3.06628 2.77148 3.95718 2.77148H12.0428C12.9337 2.77148 13.3799 3.84863 12.7499 4.47859L8.70711 8.52141C8.31658 8.91193 7.68342 8.91193 7.29289 8.52141Z",
		fill: "#7C7C7C"
	})
});
export default SvgSort;
